export default [
    {
        value: '#fffffe',
        label: 'white #31',
        index: 31,
    },
    {
        value: '#d0d0d0',
        label: 'light grey #32',
        index: 32,
    },
    {
        value: '#808080',
        label: 'dark grey #33',
        index: 33,
    },
    {
        value: '#080808',
        label: 'black #34',
        index: 34,
    },
    {
        value: '#e6d8c1',
        label: 'cream #35',
        index: 35,
    },
    {
        value: '#f7f02a',
        label: 'yellow #36',
        index: 36,
    },
    {
        value: '#f7df76',
        label: 'mango #37',
        index: 37,
    },
    {
        value: '#ffc580',
        label: 'gold #38',
        index: 38,
    },
    {
        value: '#ff5b45',
        label: 'orange #39',
        index: 39,
    },
    {
        value: '#f00',
        label: 'red #40',
        index: 40,
    },
    {
        value: '#ff2e74',
        label: 'rubin #41',
        index: 41,
    },
    {
        value: '#c23a65',
        label: 'wine #42',
        index: 42,
    },
    {
        value: '#99466e',
        label: 'berry #43',
        index: 43,
    },
    {
        value: '#8c4031',
        label: 'chocolat #44',
        index: 44,
    },
    {
        value: '#1aaae7',
        label: 'sky blue #45',
        index: 45,
    },
    {
        value: '#3662c5',
        label: 'royal blue #46',
        index: 46,
    },
    {
        value: '#15159a',
        label: 'midnight blue #47',
        index: 47,
    },
    {
        value: '#34bac6',
        label: 'carribean #48',
        index: 48,
    },
    {
        value: '#28909d',
        label: 'teal #49',
        index: 49,
    },
    {
        value: '#6c7093',
        label: 'slate #50',
        index: 50,
    },
    {
        value: '#e9c5e1',
        label: 'rose #51',
        index: 51,
    },
    {
        value: '#e563c5',
        label: 'purple #52',
        index: 52,
    },
    {
        value: '#ba9bde',
        label: 'grape #53',
        index: 53,
    },
    {
        value: '#4a1644',
        label: 'aubergine #54',
        index: 54,
    },
    {
        value: '#15bd93',
        label: 'forest #55',
        index: 55,
    },
    {
        value: '#16a090',
        label: 'cedar #56',
        index: 56,
    },
    {
        value: '#ceff52',
        label: 'flour yellow #57',
        index: 57,
    },
    {
        value: '#98f0a6',
        label: 'flour green #58',
        index: 58,
    },
    {
        value: '#fd86c0',
        label: 'flour pink #59',
        index: 59,
    },
    {
        value: '#ff8300',
        label: 'flour orange #60',
        index: 60,
    },
];
